// extracted by mini-css-extract-plugin
export default {"content":"checkbox_content__bSpqE","input":"checkbox_input__Qgwuf","label":"checkbox_label__n26zZ"};